import { useEffect, useState } from 'react';
import {
  CONSUMER_CMS_SHOPPING_CART,
  errorMock,
  handleTimer,
  IGenericErrorCMS,
  IGlobalConfigCMS,
  IPersonalInfoCMS,
  IProduct,
  OTP_CHOICE,
  useCmsConfig,
  useGenerateOTP,
  useVerifyOTP,
} from '@vfit/consumer/data-access';
import {
  errorManager,
  ErrorService,
  getClickToCallWithKeyOrUrl,
  resetData,
  trackView,
} from '@vfit/shared/data-access';
import { API } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { organizeOtp, Otp } from '@vfit/consumer/components';
import { ICommonData } from '@vfit/shared/models';
import { useCheckout } from '../../../iBuyFixed.context';
import { getTrackError } from '../../checkout.utils';
import TaggingOtpCard from './otpCard.tagging';

const OtpCard = ({ handleOnChangeEnableGoNext, handleGoPrevSlide }: ICommonData) => {
  const queryClient = useQueryClient();
  const {
    currentStepKey,
    checkoutErrors,
    findCaller,
    isModalButtonSticky,
    product,
    timerID,
    setFindCaller,
    setIsDisabledBackButton,
    setTimerID,
  } = useCheckout();
  const {
    mutate: generateOtp,
    isError: isGenerateError,
    error: errorGenerateOtp,
    isSuccess: isGenerateSuccess,
  } = useGenerateOTP();
  const {
    mutate,
    data,
    isSuccess: isSuccessVerifyOtp,
    isError: isErrorOtp,
    isLoading,
    error: verifyOtpErrorData,
  } = useVerifyOTP();

  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR
  ) as IGenericErrorCMS;
  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA
  ) as IPersonalInfoCMS;

  const [isError, setIsError] = useState(false);
  const [isTimerActive, setIsTimerActive] = useState(false);

  const handleSendOtp = (field: string, fieldType: string) => {
    resetData(queryClient, ['generateOTP']);
    generateOtp({
      identifier: field,
      identifierType: fieldType,
    });
    if (
      dataFromCms?.personalinfo?.clientRecognition?.timer?.amount &&
      !isNaN(parseInt(dataFromCms?.personalinfo?.clientRecognition?.timer?.amount)) &&
      parseInt(dataFromCms?.personalinfo?.clientRecognition?.timer?.amount) > 0
    ) {
      clearInterval(timerID);
      setIsTimerActive(true);
      const timer = handleTimer(
        parseInt(dataFromCms?.personalinfo?.clientRecognition?.timer?.amount),
        () => setIsTimerActive(false)
      );
      setTimerID(timer);
    }
  };

  const handleVerify = (otp: string) => {
    mutate(otp);
  };

  const handleSetError = () => {
    setIsError(false);
  };

  const cmsGlobalConfig = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GLOBAL_CONFIG
  ) as IGlobalConfigCMS;

  const globalConfig = cmsGlobalConfig?.globalconfig;

  const numOfFailures = parseInt(localStorage.getItem('numOfOtpFailures') || '0', 10);

  // useEffect(() => {
  //   if (isGenerateError && handleGoPrevSlide) {
  //     checkoutErrors?.showAndTrackError?.(
  //       genericError,
  //       handleGoPrevSlide,
  //       errorMock('generateOtp', errorGenerateOtp),
  //       undefined,
  //       undefined,
  //       handleGoPrevSlide,
  //       genericError?.genericerror?.buttonLabel || '',
  //       () =>
  //         getClickToCallWithKeyOrUrl(
  //           queryClient,
  //           product?.genericErrorCallMeNow?.url || '',
  //           product,
  //           () => handleGoPrevSlide(),
  //           currentStepKey,
  //           errorMock('generateOtp', errorGenerateOtp)
  //         ),
  //       product?.genericErrorCallMeNow?.label || '',
  //       isModalButtonSticky,
  //       true
  //     );
  //   }
  // }, [isGenerateError]);

  useEffect(() => {
    if (!isGenerateError) {
      return;
    }

    if (numOfFailures < (globalConfig?.otp?.maxFailureNumber || 0)) {
      localStorage.setItem('numOfOtpFailures', (numOfFailures + 1).toString());
    } else {
      const otpError = globalConfig?.otp?.adHocError || {};
      if (isGenerateError && handleGoPrevSlide) {
        checkoutErrors?.showAndTrackError?.(
          genericError,
          handleGoPrevSlide,
          errorMock('generateOtp', errorGenerateOtp),
          undefined,
          undefined,
          handleGoPrevSlide,
          genericError?.genericerror?.buttonLabel || '',
          () =>
            getClickToCallWithKeyOrUrl(
              queryClient,
              product?.genericErrorCallMeNow?.url || '',
              product,
              () => handleGoPrevSlide(),
              currentStepKey,
              errorMock('generateOtp', errorGenerateOtp)
            ),
          product?.genericErrorCallMeNow?.label || '',
          isModalButtonSticky,
          true
        );
      }
      const redirect = () => {
        window.open(otpError?.buttonLink || '', '_self');
      };
      errorManager.handleError(ErrorService.getSeverityErrorHigh(), {
        title: otpError?.title || '',
        message: otpError?.description || '',
        onClose: redirect,
        actionEvent: redirect,
        actionText: otpError?.buttonLabel || '',
        trackError: getTrackError(errorMock(`generate`, errorGenerateOtp || undefined)),
      });
    }
  }, [isGenerateError]);

  useEffect(() => {
    const handleUnload = () => {
      localStorage.removeItem('numOfOtpFailures');
    };
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []);

  useEffect(() => {
    if (isErrorOtp || (!isErrorOtp && isSuccessVerifyOtp && !data)) {
      setIsError(true);
      if (verifyOtpErrorData) {
        trackView({
          ...getTrackError(errorMock('VerifyOtp', verifyOtpErrorData), 'OTP'),
          page_error_code: verifyOtpErrorData.status || '',
        });
      }
    }
  }, [isSuccessVerifyOtp, data, isErrorOtp]);

  useEffect(() => {
    if (handleOnChangeEnableGoNext) {
      setFindCaller({ ...findCaller, isVerified: !!data, verifyOtp: (data as any)?.id || '' });
      localStorage.setItem(OTP_CHOICE, findCaller?.selectedContactMedium?.fieldType || '');
      resetData(queryClient, ['findCaller']);
      handleOnChangeEnableGoNext(!!data);
    }
  }, [data]);

  useEffect(() => {
    setIsDisabledBackButton(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  useEffect(() => {
    if (findCaller.selectedContactMedium?.field)
      handleSendOtp(
        findCaller.selectedContactMedium.field,
        findCaller.selectedContactMedium.fieldType
      );
  }, []);

  return (
    <>
      <TaggingOtpCard />
      <Otp
        product={product as IProduct}
        contactMedium={findCaller.selectedContactMedium}
        isError={isError}
        isSuccessVerifyOtp={isSuccessVerifyOtp}
        isLoading={isLoading}
        reSendOtp={handleSendOtp}
        onVerify={handleVerify}
        setIsError={handleSetError}
        configOtp={organizeOtp(
          dataFromCms?.personalinfo,
          findCaller?.selectedContactMedium?.fieldType === 'msisdn',
          findCaller?.selectedContactMedium
        )}
        isTimerActive={isTimerActive}
      />
    </>
  );
};

export default OtpCard;

